"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Menü-Widget.
 *
 * @class
 * @extends gc.gis.widget.GCItem
 * @memberof gc.gis.widget
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {Array<Object<string,*>>} options.items
 * @param {string} [options.direction=left] Richtungs-Klasse. <code>left</code> (default) oder <code>right</code>.
 */
gc.gis.widget.GCMenu = function( options )
{
	this.items = options.items || [];
	this._menu_direction = options.direction || 'left';

	gc.gis.widget.GCItem.call( this, options );
};
gc.gis.widget.GCMenu.prototype = Object.create( gc.gis.widget.GCItem.prototype );

gc.gis.widget.GCMenu.prototype.getItems = function()
{
	return this.items;
};

gc.gis.widget.GCMenu.prototype.addItem = function( item )
{
	this.addItems( item );
};

gc.gis.widget.GCMenu.prototype.addItems = function( items )
{
	if( typeof items === 'Array' )
	{
		for( var i=0; i<items.length; i++ )
		{
			this.items.push( items[i] );
		}
	}
	else
	{
		this.items.push( items );
	}
	this._render();
	return this;
};

/**
 * @inheritdoc
 */
gc.gis.widget.GCMenu.prototype._render = function()
{
	var self = this;
	var items = this.getItems();

	// Label
	this.element_control = undefined;
	if( this.label || this.icon || this.tooltip )
	{
		// Labeltext
		var element_label_text = jQuery('<span>', {
			'class': 'gc-widget-label-text',
			text: (self.label ? self.label : '')
		});

		// Labelelement
		this.element_control = jQuery('<button>', {
			title: self.tooltip ? self.tooltip : self.label,
			'class': 'gc-button dropdown-toggle gc-widget-label'
				+ (self.tooltip ? ' gc-widget-tooltip' : '')
				+ (self.badge ? ' gc-widget-badge' : '')
				+ (self.className ? ' '+ self.className : ''),
			'aria-haspopup': true,
			'aria-expanded': false,
			'data-toggle': 'dropdown',
			click: function( evt ) {
				evt.preventDefault();
				try
				{
					// execute additional actions
					if (self.action) {
						self.action.execute(self);
					}
					if (self.click) {
						self.click.call(this, evt);
					}
				}
				catch( err )
				{
					gc.gis.iface.log.error( self, err );
				}
				jQuery(this).blur();
			}
		});

		if( self.icon ) {
			self.element_control.append( jQuery('<span>', {
				'class': 'gc-icon '+ self.icon
			}) );
		}
		if( self.label ) {
			self.element_control.append( element_label_text );
		}
		if(self.tooltip)
		{
			gc.gis.iface.ui.tooltip(this.element_control);
		}
		self.element_control.append( jQuery('<span>', {
			'class': 'caret'
		}) );
		if( self.badge ) {
			self.element_control.append( self.badge.getElement() );
		}
	}

	// Item-Liste
	var menu_direction = this._menu_direction;
	this.element_ul = jQuery('<ul>', {
		'class': 'gc-widget-menu-items dropdown-menu dropdown-menu-'+ menu_direction
	});
	var li;
	for( var i=0; i<items.length; i++ )
	{
		// getrennte Menügruppen
		if( items[i].length > 0 )
		{
			var list = items[i];

			//ul = jQuery('<ul>');
			if( i > 0 )
			{
				this.element_ul.append( jQuery('<li>', {
					'class': 'divider'
				}) );
			}
			for( var j=0; j<list.length; j++ )
			{
				li = jQuery('<li>');
				li.append( list[j].getElement() );
				this.element_ul.append( li );
			}
		}
		// keine Menügruppen
		else
		{
			li = jQuery('<li>');
			li.append( items[i].getElement() );
			this.element_ul.append( li );
		}
	}

	// Container
	if( !this.element )
	{
		this.element = jQuery('<div>', {
			'class': 'gc-widget gc-widget-item gc-widget-menu'
				+ (self.containerClassName ? ' '+ self.containerClassName : '')
		});
	}
	else
	{
		this.element.children().remove();
	}

	if( this.element_control ) {
		this.element.append( this.element_control );
	}
	this.element.append( this.element_ul );

	return this.element;
};

